module.exports = __webpack_public_path__ + "img/abbb_pack.332c3fc4.png";